import { createSlice, Dispatch, PayloadAction } from "@reduxjs/toolkit";
import { GetStateFn } from "../../utils/dispatchUtils";

export const idManagerViewOptionsSliceName = "idManager";

export enum IdManagerViewColumn {
  CONNECTED = "connected",
  NAME = "name",
  DESCRIPTION = "description",
  COLOR = "color",
}

export const idManagerIdViewColumnIds = [
  IdManagerViewColumn.CONNECTED,
  IdManagerViewColumn.NAME,
  IdManagerViewColumn.DESCRIPTION,
];
export const idManagerIdColorViewColumnIds = [
  IdManagerViewColumn.CONNECTED,
  IdManagerViewColumn.NAME,
  IdManagerViewColumn.DESCRIPTION,
  IdManagerViewColumn.COLOR,
];
export type IdManagerViewOptionsState = {
  idColumns: string[];
  idColorColumns: string[];
};

const persistedIdManagerViewOptions = localStorage.getItem(idManagerViewOptionsSliceName);
const persistedState = persistedIdManagerViewOptions ? JSON.parse(persistedIdManagerViewOptions) as IdManagerViewOptionsState : null;
const fallback: IdManagerViewOptionsState = {
  idColumns: idManagerIdViewColumnIds,
  idColorColumns: idManagerIdColorViewColumnIds,
};
const initialState: IdManagerViewOptionsState = persistedState ?? fallback;
// if columns does not exist, set default fallback value
if (initialState.idColumns === undefined || initialState.idColumns.length === 0) {
  initialState.idColumns = fallback.idColumns;
}
if (initialState.idColorColumns === undefined || initialState.idColorColumns.length === 0) {
  initialState.idColorColumns = fallback.idColorColumns;
}

const idManagerViewOptionsSlice = createSlice({
  name: idManagerViewOptionsSliceName,
  initialState,
  reducers: {
    setIdManagerViewIdColumns(state: IdManagerViewOptionsState, action: PayloadAction<string[]>) {
      state.idColumns = action.payload;
    },
    setIdManagerViewIdColorColumns(state: IdManagerViewOptionsState, action: PayloadAction<string[]>) {
      state.idColorColumns = action.payload;
    },
  },
});

export type IdManagerViewOptionsRootState = { [idManagerViewOptionsSliceName]: IdManagerViewOptionsState };
export const selectIdManagerViewOptions = (state: IdManagerViewOptionsRootState) => state[idManagerViewOptionsSliceName];
export const setIdManagerViewIdColumns = (columns: string[]) => (dispatch: Dispatch, getState: GetStateFn) => {
  dispatch(idManagerViewOptionsSlice.actions.setIdManagerViewIdColumns(columns));
  persistState(getState);
};
export const setIdManagerViewIdColorColumns = (columns: string[]) => (dispatch: Dispatch, getState: GetStateFn) => {
  dispatch(idManagerViewOptionsSlice.actions.setIdManagerViewIdColorColumns(columns));
  persistState(getState);
};

function persistState(getState: GetStateFn) {
  localStorage.setItem(idManagerViewOptionsSliceName, JSON.stringify(
    selectIdManagerViewOptions(getState()),
  ));
}

export const idManagerViewOptionsReducer = idManagerViewOptionsSlice.reducer;
